import { render, staticRenderFns } from "./EdInputTextArea.vue?vue&type=template&id=92e71972&"
import script from "./EdInputTextArea.vue?vue&type=script&lang=js&"
export * from "./EdInputTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports